import type React from 'react';

import { Avatar, Button, Modal, ModalBody, ModalFooter, ModalHeader, Text } from '@change/ds-core-ui';

import { useI18n } from '@change-corgi/core-react/i18n';

import type { AdvocateAvatarProps } from '../../types';

import { useAdvocateInfo } from './hooks';

export const AdvocateInfo: React.FC<AdvocateAvatarProps> = ({ hasAdvocatesState, petitionAdvocates }) => {
	const { title, subtitle, hasExtraAdvocates } = useAdvocateInfo({
		hasAdvocatesState,
		petitionAdvocates,
	});
	const { translate } = useI18n();

	return (
		<div className="flex flex-col">
			<Text variant="body" size="large" fontWeight="bold" className="text-typography-strong">
				{title}
			</Text>
			{hasExtraAdvocates ? (
				<Modal
					trigger={
						<Button
							variant="tertiary"
							size="small"
							className="text-typography-weak w-fit p-0 hover:bg-transparent! active:bg-transparent!"
							data-qa="advocates-list-button"
						>
							{subtitle}
						</Button>
					}
					onClose={() => {}}
					closeButtonAriaLabel={translate('corgi.components.modal.close_button')}
				>
					<ModalHeader title={title} />
					<ModalBody>
						{petitionAdvocates &&
							petitionAdvocates.map((advocate) => {
								if (!advocate) return null;
								return (
									<div key={advocate.id} className="flex items-center gap-3 last:mb-2">
										<Avatar
											size="medium"
											src={advocate.photo?.userSmall.url}
											initial={!advocate.photo?.userSmall.url ? advocate.firstName.charAt(0) : undefined}
											alt={translate('corgi.petition.advocates.avatar_alt', {
												firstName: advocate.firstName,
												lastInitial: advocate.lastInitial ?? undefined,
											})}
											className="border-stroke-inverse-strong bg-icon-disabled shrink-0 border"
										/>
										<Text variant="body" size="small" fontWeight="bold" className="text-typography-strong">
											{advocate.firstName} {advocate.lastInitial}
										</Text>
									</div>
								);
							})}
					</ModalBody>
					<ModalFooter>
						{({ close }) => (
							<Button onClick={close} data-qa="advocates-list-close-modal-button" variant="primary">
								{translate('corgi.petition.advocates.close_modal')}
							</Button>
						)}
					</ModalFooter>
				</Modal>
			) : (
				<Text variant="body" className="text-typography-weak p-0 text-start">
					{subtitle}
				</Text>
			)}
		</div>
	);
};
